import React from 'react';
import { createMarkup } from 'utils/html.util';

import * as S from './MinimumOrderNotification.style';

const MinimumOrderNotification = ({
  showNotification,
  message,
  withColor,
  thresholdPercentage,
}: {
  showNotification: boolean;
  message: string;
  withColor?: boolean;
  thresholdPercentage: number | null;
}) => {
  const shouldShowProgressBar = thresholdPercentage !== null && thresholdPercentage < 100;

  return showNotification && message ? (
    <S.MinimumOrderNotification>
      <S.Message as="p" dangerouslySetInnerHTML={createMarkup(message)} withColor={withColor} />

      {shouldShowProgressBar && (
        <S.ProgressBar role="progressbar">
          <S.FilledProgressBar width={thresholdPercentage} />
        </S.ProgressBar>
      )}
    </S.MinimumOrderNotification>
  ) : null;
};

export default MinimumOrderNotification;
